import React from "react";

const ProductDetailSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Skeleton */}
      <div className="bg-white sticky top-0 z-40 border-b border-gray-200">
        <div className="px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-4 h-4 bg-gray-300 rounded animate-pulse mr-2"></div>
              <div className="w-16 h-4 bg-gray-300 rounded animate-pulse"></div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gray-300 rounded-lg animate-pulse"></div>
              <div className="w-8 h-8 bg-gray-300 rounded-lg animate-pulse"></div>
              <div className="w-8 h-8 bg-gray-300 rounded-lg animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-3 py-3 pb-32 sm:pb-4">
        {/* Product Layout Skeleton */}
        <div className="bg-white border border-gray-200 rounded-lg mb-3">
          <div className="p-3">
            {/* Top Row: Image + Product Info */}
            <div className="flex flex-col lg:flex-row lg:items-start gap-4">
              {/* Product Image Skeleton */}
              <div className="flex-shrink-0 w-full lg:w-auto flex justify-center lg:justify-start">
                <div className="w-20 h-20 lg:w-18 lg:h-18 bg-gray-200 rounded-lg animate-pulse"></div>
              </div>

              {/* Product Details Skeleton */}
              <div className="flex-1 space-y-3">
                {/* Product Name */}
                <div className="space-y-2">
                  <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-1/3"></div>
                </div>

                {/* Price Grid Skeleton */}
                <div className="grid gap-2 grid-cols-2 sm:grid-cols-4">
                  <div className="bg-gray-100 p-2 rounded-lg">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2 mb-1"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-lg">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2 mb-1"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-lg">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2 mb-1"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  </div>
                  <div className="bg-gray-100 p-2 rounded-lg">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2 mb-1"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  </div>
                </div>

                {/* Action Buttons Skeleton */}
                <div className="flex flex-wrap gap-1.5">
                  <div className="h-8 bg-gray-200 rounded-lg animate-pulse w-24"></div>
                  <div className="h-8 bg-gray-200 rounded-lg animate-pulse w-24"></div>
                  <div className="h-8 bg-gray-200 rounded-lg animate-pulse w-24"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Charts Section Skeleton */}
        <div className="space-y-3">
          {/* Price History Chart Skeleton */}
          <div className="bg-white border border-gray-200 rounded-lg p-3">
            <div className="flex items-center justify-between mb-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="h-[180px] bg-gray-100 rounded animate-pulse"></div>
          </div>

          {/* Inventory Chart Skeleton */}
          <div className="bg-white border border-gray-200 rounded-lg p-3">
            <div className="flex items-center justify-between mb-2">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="h-[180px] bg-gray-100 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Store Location Card Skeleton */}
        <div className="mt-6">
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-48"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-40"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
